import { Time } from '@instinet-analytics/core-lib';

export interface OrderVolumeProfileComponentState {
    startTime?: Time;
    endTime?: Time;
}

export const initialOrderVolumeProfileComponentState: OrderVolumeProfileComponentState =
    {};
